import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PortalDashboardCTAPanelModel } from './portal-dashboard-cta.model';
import { PortalDashboardCTAService } from './portal-dashboard-cta.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-portal-dashboard-cta',
  templateUrl: './portal-dashboard-cta.component.html',
  styleUrls: ['./portal-dashboard-cta.component.scss'],
  standalone: false
})
export class PortalDashboardCTAComponent implements OnInit {
  @Output() loadedComplete: EventEmitter<boolean> = new EventEmitter<boolean>();
  panels: PortalDashboardCTAPanelModel[] = [];
  fromRequestInProgress = false;

  constructor(
    private portalDashboardCTAService: PortalDashboardCTAService,
    private router: Router
  ) {}
  async ngOnInit(): Promise<void> {
    this.panels = await this.portalDashboardCTAService.getCTAPanels();
    this.loadedComplete.emit(true);
  }

  async redirectToForm(formId: string): Promise<void> {
    this.fromRequestInProgress = true;
    const applicationLinkl = await this.portalDashboardCTAService.getApplicationLink(formId);
    this.fromRequestInProgress = false;
    if (!applicationLinkl?.link) return;
    this.router.navigateByUrl(applicationLinkl.link);
  }
}
